<template>
  <span class="small text-nowrap">
    <template v-for="(document, index) in PUBLIC_LEGAL_DOCUMENTS" :key="document.path">
      <template v-if="index > 0"> and </template>
      <a :href="document.path" target="_blank" class="text-success">{{ document.label }}</a>
    </template>
  </span>
</template>

<script setup>
import { PUBLIC_LEGAL_DOCUMENTS } from "@/constants/legalDocuments";
</script>
